/**
 * Login Component
 *
 * Simple login form for authentication
 */

import { useState } from "react";
import { useAuth } from "../../context/AuthContext";

// Material Dashboard 2 React components
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import MDAlert from "../../components/MDAlert";

// Material Dashboard 2 React example components
import PageLayout from "../../examples/LayoutContainers/PageLayout";

// Images
import bgImage from "../../assets/images/bg-sign-in-basic.jpeg";

function Login() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    if (!password.trim()) {
      setError("Please enter a password");
      setIsLoading(false);
      return;
    }

    const success = login(password);

    if (!success) {
      setError("Invalid password. Please try again.");
      setPassword("");
    }

    setIsLoading(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  return (
    <PageLayout image={bgImage}>
      <MDBox
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
        mx={2}
        mt={-3}
        p={2}
        mb={1}
        textAlign="center"
      >
        <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
          Social Media Hub
        </MDTypography>
        <MDTypography display="block" variant="button" color="white" my={1}>
          Enter your password to access the content hub
        </MDTypography>
      </MDBox>

      <MDBox pt={4} pb={3} px={3}>
        <MDBox component="form" role="form" onSubmit={handleSubmit}>
          {error && (
            <MDBox mb={2}>
              <MDAlert color="error" dismissible onClose={() => setError("")}>
                {error}
              </MDAlert>
            </MDBox>
          )}

          <MDBox mb={2}>
            <MDInput
              type="password"
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={handleKeyPress}
              fullWidth
              disabled={isLoading}
              autoFocus
            />
          </MDBox>

          <MDBox mt={4} mb={1}>
            <MDButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? "Signing in..." : "Sign In"}
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </PageLayout>
  );
}

export default Login;
